import { INHOUSE_SUPPLY_TYPE_DTO } from '../constants/supplyTypeDto';
import { SupplyType } from '../entities';

type SupplyTypeDto = {
  type: string;
};

export function mapSupplyTypeDtoToEntity(dto: SupplyTypeDto): SupplyType {
  return dto.type === INHOUSE_SUPPLY_TYPE_DTO ? SupplyType.INHOUSE : SupplyType.MARKET;
}
